import React from 'react';
import { Box } from '@mui/material';
import 'react-alice-carousel/lib/alice-carousel.css'; // requires a loader
import AliceCarousel from 'react-alice-carousel';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
const CarouselInterHoliday = () => {
	// const { hotel } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const history = useHistory();
	const responsive = {
		0: { items: 1 },
		568: { items: 2 },
		1024: { items: 4 },
	};
	const items = Array.from(Array(10)).map((i, index) => {
		return (
			<div
				onClick={() => history.push('/holidayresult')}
				style={{ cursor: 'pointer', marginTop: 20 }}
				className='item'
				data-value='1'>
				<Box style={{ width: '90%' }}>
					<Box>
						<img
							src={
								'https://img.veenaworld.com/group-tours/india/north-east/newm/newm-newm-1522023.jpg'
							}
							style={{ width: '100%', height: 160, borderRadius: 5 }}
						/>
					</Box>
					<Box style={{ textAlign: 'initial', padding: 10 }}>
						<span
							style={{
								color: '#0c2f54',
								// fontFamily: '"Poppins", sans-serif',
								fontWeight: 'bold',
								fontSize: 14,
							}}>
							{'Women Special Assam Meghalaya'}
						</span>
						<br></br>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								<i class='far fa-clock'></i>
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{8} Days
								</span>
							</Box>
							<Box display='flex' alignItems='center' ml={'10px'}>
								<i class='far fa-moon'></i>
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 14,
									}}>
									{5} Nights
								</span>
							</Box>
						</Box>
						<Box display='flex' alignItems='center' style={{ marginTop: 5 }}>
							<Box display='flex' alignItems='center'>
								{/* <i class='far fa-clock'></i> */}
								<span
									style={{
										color: '#0c2f54',
										// fontFamily: '"Poppins", sans-serif',
										fontWeight: 'bold',
										marginLeft: 5,
										fontSize: 16,
									}}>
									₹ 968548
								</span>
							</Box>
						</Box>
					</Box>
					{/* <Box style={{ background: '#0c2e53', padding: 10 }}>
						<span style={{ color: 'white' }}> Starting From ₹{800} </span>
					</Box> */}
				</Box>
			</div>
		);
	});
	const demo = [
		<div className='item' data-value='1'>
			1
		</div>,
		<div className='item' data-value='2'>
			2
		</div>,
		<div className='item' data-value='3'>
			3
		</div>,
		<div className='item' data-value='4'>
			4
		</div>,
		<div className='item' data-value='5'>
			5
		</div>,
	];

	return (
		<AliceCarousel
			autoPlay
			infinite
			mouseTracking
			items={items}
			autoPlayInterval={3000}
			responsive={responsive}
			controlsStrategy='alternate'
			keyboardNavigation={true}
			renderPrevButton={() => {
				return <></>;
			}}
			renderNextButton={() => {
				return <></>;
			}}
		/>
	);
};

export default CarouselInterHoliday;
